{
  "$schema": "http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#",
  "description": "Schema for Code Suggestion events",
  "self": {
    "vendor": "com.gitlab",
    "name": "code_suggestions_context",
    "version": "3-5-0",
    "format": "jsonschema"
  },
  "type": "object",
  "required": ["gitlab_realm"],
  "additionalProperties": false,
  "properties": {
    "gitlab_realm": {
      "type": "string",
      "description": "Self-Managed or SaaS",
      "enum": ["self-managed", "saas"]
    },
    "gitlab_host_name": {
      "type": ["string", "null"],
      "description": "Host name of the GitLab instance where the request comes from",
      "maxLength": 255
    },
    "gitlab_instance_id": {
      "type": ["string", "null"],
      "description": "ID of the GitLab instance where the request comes from",
      "maxLength": 255
    },
    "gitlab_instance_version": {
      "description": "GitLab version, e.g. 17.2.0",
      "type": ["string", "null"],
      "maxLength": 32
    },
    "gitlab_global_user_id": {
      "type": ["string", "null"],
      "description": "Globally unique user ID",
      "maxLength": 64
    },
    "gitlab_saas_duo_pro_namespace_ids": {
      "description": "List of the namespace IDs that the user has a Duo Pro Add-Onn provisioned from (available GitLab.com only)",
      "type": ["array", "null"],
      "items": {
        "description": "ID of the namespace",
        "type": "integer",
        "minimum": 0,
        "maximum": 2147483647
      }
    },
    "language": {
      "type": ["string", "null"],
      "description": "Programming language of the completions request",
      "maxLength": 32
    },
    "model_engine": {
      "type": ["string", "null"],
      "description": "Model engine used for the completions",
      "maxLength": 64
    },
    "model_name": {
      "type": ["string", "null"],
      "description": "Model name used for the completions",
      "maxLength": 64
    },
    "prefix_length": {
      "type": ["integer", "null"],
      "description": "Length of the prefix in characters",
      "minimum": 0,
      "maximum": 2147483647
    },
    "suffix_length": {
      "type": ["integer", "null"],
      "description": "Length of the suffix in characters",
      "minimum": 0,
      "maximum": 2147483647
    },
    "suggestion_source": {
      "type": ["string", "null"],
      "description": "Suggestion source: cache or network",
      "enum": ["cache", "network"]
    },
    "api_status_code": {
      "type": ["integer", "null"],
      "description": "HTTP status code of GitLab API",
      "minimum": 0,
      "maximum": 599
    },
    "debounce_interval": {
      "type": ["integer", "null"],
      "description": "Number of milliseconds we wait between last keystroke and API request for suggestions",
      "minimum": 0,
      "maximum": 4000
    },
    "is_streaming": {
      "description": "Whether the suggestion is streamed to the client",
      "type": ["boolean", "null"]
    },
    "is_invoked": {
      "type": ["boolean", "null"],
      "description": "Whether the suggestion was invoked by user (requesting more options) or triggered automatically"
    },
    "options_count": {
      "type": ["integer", "null"],
      "description": "Number of suggestion options provided to the client",
      "minimum": 0,
      "maximum": 2147483647
    },
    "accepted_option": {
      "type": ["integer", "null"],
      "description": "Suggestion option number that was accepted",
      "minimum": 1,
      "maximum": 2147483647
    },
    "has_advanced_context": {
      "description": "Whether the suggestion was requested with additional context",
      "type": ["boolean", "null"]
    },
    "is_direct_connection": {
      "description": "Whether the suggestion request was sent to monolith or directly to AI gateway",
      "type": ["boolean", "null"]
    },
    "total_context_size_bytes": {
      "type": ["integer", "null"],
      "description": "Total byte size of all context items in request",
      "minimum": 0,
      "maximum": 9223372036854775807
    },
    "content_above_cursor_size_bytes": {
      "type": ["integer", "null"],
      "description": "Total byte size of text above cursor",
      "minimum": 0,
      "maximum": 9223372036854775807
    },
    "content_below_cursor_size_bytes": {
      "type": ["integer", "null"],
      "description": "Total byte size of text below cursor",
      "minimum": 0,
      "maximum": 9223372036854775807
    },
    "context_items": {
      "type": ["array", "null"],
      "description": "Set of final context items sent to AI Gateway",
      "items": {
        "type": "object",
        "description": "Individual context item",
        "properties": {
          "file_extension": {
            "type": "string",
            "description": "File extension of the context item",
            "maxLength": 32
          },
          "type": {
            "type": "string",
            "description": "Type of the context item",
            "maxLength": 64
          },
          "resolution_strategy": {
            "type": "string",
            "description": "Strategy used to resolve the context item",
            "maxLength": 64
          },
          "byte_size": {
            "type": "integer",
            "description": "Size of the context item in bytes",
            "minimum": 0,
            "maximum": 9223372036854775807
          }
        }
      }
    },
    "input_tokens": {
      "type": ["integer", "null"],
      "description": "Total tokens used in request to model provider",
      "minimum": 0,
      "maximum": 2147483647
    },
    "output_tokens": {
      "type": ["integer", "null"],
      "description": "Total output tokens received from model provider",
      "minimum": 0,
      "maximum": 2147483647
    },
    "context_tokens_sent": {
      "type": ["integer", "null"],
      "description": "Total tokens sent as context to AI Gateway",
      "minimum": 0,
      "maximum": 2147483647
    },
    "context_tokens_used": {
      "type": ["integer", "null"],
      "description": "Total context tokens used in request to model provider",
      "minimum": 0,
      "maximum": 2147483647
    }
  }
}
